const Inc = {
	MODAL_STYLE: {
		overlay: {
			zIndex: "100",
			backgroundColor: "transparent",
			width: "100%",
			margin: "0",
		},
		content: {
			top: "50%",
			left: "50%",
			right: "auto",
			bottom: "auto",
			padding: "0",
			transform: "translate(-50%, -50%)",
			backgroundColor: "transparent",
			borderRadius: "0",
			borderWidth: "0",
		}
	},
	FACE_ICON: ["user-tie","user-nurse","user-secret","user-graduate"],
}
export default Inc;